import { useMemo } from 'react';
import employeeVal, { Employee } from '../content/blank/allEmployees.val';
import { useVal } from '../val/val.client';

export function useContactPeople(): Employee[] {
  const employees = useVal(employeeVal);
  const contactPeople = useMemo(() => {
    return Object.values(employees).filter(
      (employee) => employee.contactPerson
    );
  }, [employees]);
  return contactPeople;
}
